import UAParser from "ua-parser-js";

export function useOS() {
  const parser = new UAParser();
  const { os } = parser.getResult();
  return os;
}
